import React, { useState } from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import EmployeeLeaveInforModal from "./EmployeeLeaveInforModal";
const localizer = momentLocalizer(moment);

function CalendarView({ eventData }) {
  const events = eventData?.map((item) => ({
    title: item.name,
    allDay: true,
    start: new Date(item.startDate),
    end: new Date(item.endDate),
    resource: item.employeeId,
  }));
  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal(!modal);
  };
  const [propsData, setPropsData] = useState({});
  return (
    <div className="calendarContainer">
      <Calendar
        events={events}
        views={[Views.MONTH, Views.WORK_WEEK, Views.DAY]}
        step={60}
        showMultiDayTimes
        defaultDate={new Date()}
        onSelectEvent={(data) => {
          setPropsData(data);
          toggle();
        }}
        localizer={localizer}
      />
      <EmployeeLeaveInforModal
        toggle={toggle}
        modal={modal}
        leaveData={propsData}
      />
    </div>
  );
}

export default CalendarView;
